import axios from "axios";
import serviceConfig from "config/serviceConfig";

const apiClient = axios.create({
	baseURL: serviceConfig.api.baseUrl,
	headers: {
		"Content-Type": serviceConfig.headers.contentType,
		Accept: serviceConfig.headers.accept,
	},
});

export default apiClient;
